var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaContentLoadingSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.30787 7.06574C4.52914 6.23994 5.00918 5.50675 5.6776 4.97371C6.34601 4.44066 7.16763 4.13579 8.02197 4.10382C8.87631 4.07184 9.71842 4.31444 10.4248 4.79603C11.1312 5.27763 11.6647 5.97288 11.9471 6.77983C12.2295 7.58679 12.2459 8.46299 11.9939 9.27995C11.7419 10.0969 11.2348 10.8116 10.5469 11.3193C9.85908 11.827 9.02665 12.101 8.17171 12.101C7.31677 12.101 6.48432 11.8272 5.79642 11.3195",
    stroke: "#363432",
    strokeOpacity: 0.96,
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaContentLoadingSpinner);
export default __webpack_public_path__ + "static/media/media-content-loading-spinner.0be97dd182d917487b0c1c987521c0fd.svg";
export { ForwardRef as ReactComponent };